import mixins from 'synergycms_core/src/less/mixins';

export default {
  invalid: {},
  defaultStyle: {
    color: '#000',
    width: '100%',
    minHeight: '120px',
    padding: '20px 0 0 15px',
    ...mixins.boxSizing(),
    ...mixins.boxShadow('0 0 2px -1px rgba(0,0,0,0.5)'),
    resize: 'vertical',
    border: '1px solid #ddd',
    maxHeight: '500px',
    font: data => '300 13px ' + data.fontFamily1,
    display: 'block',
    backgroundColor: 'transparent',
    '& $invalid': {
      marginBottom: '7px',
      borderColor: '#d0021b',
      display: 'block'
    },
    '&:lang(ar)':{
      paddingRight:'15px',
      paddingLeft:0
    }
  }
};
